<template>
  <sc-card :title="title">
    <template slot="body">
      <form
        @submit.prevent="createMarker()"
        novalidate>
        <sc-field grouped>
          <sc-input
            v-model="marker.description"
            ref="description"
            placeholder="Nome do marcador" />

          <div class="control is-clearfix">
            <sc-color-picker
              v-model="marker.color"
              :trigger-style="{ width: '36px', height: '36px', 'border-radius': '5px' }" />
          </div>

          <sc-field>
            <button class="button is-primary"
                    :class="{'is-loading': loadingMarkerSave}"
                    :disabled="loadingMarkerSave || !marker.description || !marker.color">Incluir</button>
          </sc-field>

        </sc-field>
      </form>

      <section class="hero">
        <div class="hero-body">
          <div class="columns">

            <div :key="marker.id"
                 class="column is-narrow"
                 v-for="marker in markers">

              <div>
                <sc-recon-marker
                  :marker="marker"
                  :is-deleted="true"
                  @delete="deleteMarker"/>
                <sc-color-picker
                  v-model="marker.color"
                  @input="updateMarker(marker)"
                  :trigger-style="{
                    width: '100%',
                    margin: '5px 0'
                  }"/>
              </div>

            </div>
          </div>
        </div>
      </section>

    </template>
  </sc-card>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import {
    ScCard,
    ScField,
    ScInput,
    ScColorPicker,
  } from '@intelipost-js/secure-components';
  import ScReconMarker from '../../../components/sc-recon-marker/ScReconMarker';

  const { mapState, mapActions } = createNamespacedHelpers('recon');

  export default {
    name: 'configuration-invoice-markers',
    data() {
      return {
        title: 'Marcadores',
        color: '',
        marker: {
          description: null,
          color: '',
        },
      };
    },
    computed: {
      ...mapState([
        'loadingMarkerSave',
        'markers',
      ]),
    },
    methods: {
      ...mapActions([
        'getMarkers',
        'updateMarker',
        'deleteMarker',
      ]),
      createMarker() {
        return this.$store.dispatch('recon/createMarker', this.marker).then(() => {
          this.$refs.description.focus();
          Object.assign(this.marker, {
            description: null,
            color: null,
          });
        });
      },
    },
    beforeMount() {
      this.getMarkers();
    },
    components: {
      ScCard,
      ScField,
      ScInput,
      ScColorPicker,
      ScReconMarker,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/configuration-invoice/blocks/ConfigurationInvoiceMarkers.vue